import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRouter } from './AppRouter';
import { Layout } from './components/layout/Layout';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Layout data-id="element-1">
        <AppRouter data-id="element-2" />
      </Layout>
    </BrowserRouter>;
}